import { defineSlotRecipe } from '@chakra-ui/react';
import { tooltipAnatomy } from '@chakra-ui/react/anatomy';

export const tooltipRecipe = defineSlotRecipe({
  className: 'ac-tooltip',
  slots: tooltipAnatomy.keys(),
  base: {
    content: {
      color: 'grey.light.1',
      px: '2.5',
      py: '1',
      borderRadius: 'main',
      fontWeight: 'medium',
      fontSize: '14px',

      maxW: 'xs',
      zIndex: 'tooltip',
      transformOrigin: 'var(--transform-origin)',
      backgroundColor: 'grey.dark.2',
      borderColor: 'grey.dark.1',
      borderStyle: 'solid',
      borderWidth: '1px',

      boxShadow: '4px 4px 4px 0px rgba(17, 17, 17, 0.05)',

      _open: {
        animationStyle: 'scale-fade-in',
        animationDuration: 'fast',
      },
      _closed: {
        animationStyle: 'scale-fade-out',
        animationDuration: 'fast',
      },
    },
    arrow: {
      '--arrow-size': 'sizes.2',
      '--arrow-background': 'white',
    },
    arrowTip: {
      borderTopWidth: '1px',
      borderLeftWidth: '1px',
      borderColor: 'grey.light.2',
    },
  },
});
